import { getJiraUserByAccountId } from "../../../../redux/actions/jiraActions"

export const getUserNameFromAccountId =async (accountId,jiraUser)=>{
    if(accountId === jiraUser?.accountId){
        return jiraUser.displayName
    }

    const result = await getJiraUserByAccountId(accountId)

    return result?.displayName;
}